import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { useSocket } from '../providers/SocketProvider';

// ----------------------------------------------------------------------

export const useOnlineActivityTracking = () => {
  const location = useLocation();
  const { socket } = useSocket();
  const { account, isAuthentificated } = useAuth();
  const userId = account?._id;

  useEffect(() => {
    if (socket && isAuthentificated && userId) {
      socket.emit('userActivityUpdate', {
        userId,
        activity: 'login',
        occurredAt: new Date().toISOString(),
      });
    }
  }, [socket, isAuthentificated, userId]);

  useEffect(() => {
    if (socket && isAuthentificated && userId) {
      socket.emit('userActivityUpdate', {
        userId,
        activity: `page:${location.pathname}`,
        occurredAt: new Date().toISOString(),
      });
    }
  }, [socket, isAuthentificated, userId, location.pathname]);
};
